import React, { useMemo } from "react";
import { Calendar } from "lucide-react";
import { styles as baseStyles } from "../../style/DoctorProfile.styles";

/**
 * WeeklySchedule
 *
 * Props:
 * - workingHours?: {
 *     monday?:    { enabled?: boolean, start?: string, end?: string },
 *     tuesday?:   { enabled?: boolean, start?: string, end?: string },
 *     wednesday?: { enabled?: boolean, start?: string, end?: string },
 *     thursday?:  { enabled?: boolean, start?: string, end?: string },
 *     friday?:    { enabled?: boolean, start?: string, end?: string },
 *     saturday?:  { enabled?: boolean, start?: string, end?: string },
 *     sunday?:    { enabled?: boolean, start?: string, end?: string },
 *   }
 * - styles?: typeof baseStyles
 */
const WeeklySchedule = ({ workingHours = {}, styles = baseStyles }) => {
  const days = useMemo(
    () => [
      { key: "monday", name: "Monday" },
      { key: "tuesday", name: "Tuesday" },
      { key: "wednesday", name: "Wednesday" },
      { key: "thursday", name: "Thursday" },
      { key: "friday", name: "Friday" },
      { key: "saturday", name: "Saturday" },
      { key: "sunday", name: "Sunday" },
    ],
    []
  );

  const formatted = useMemo(() => {
    return days.map((d) => {
      const v = workingHours?.[d.key];
      const isOpen = !!(v?.enabled && v?.start && v?.end);
      return {
        name: d.name,
        time: isOpen ? `${v.start} - ${v.end}` : "Closed",
        open: isOpen,
      };
    });
  }, [days, workingHours]);

  return (
    <div style={styles.section}>
      <div style={styles.sectionHeader}>
        <Calendar style={{ width: 20, height: 20, color: "#f59e0b" }} />
        <h2 style={styles.sectionTitle}>Weekly Schedule</h2>
      </div>

      <div style={styles.sectionContent}>
        <div style={styles.availabilityGrid} className="availability-grid">
          {formatted.map((day) => (
            <div key={day.name} style={styles.dayCard}>
              <div style={styles.dayName}>{day.name}</div>
              <div style={{ ...styles.dayTime, color: day.open ? "#111827" : "#9ca3af" }}>
                {day.time}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeeklySchedule;
